import { AbstractControl, Validators, ValidatorFn } from "@angular/forms";
import { isPresent } from '../../helpers/function';

export const lt = (lt: number): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: boolean } => {
    if (!isPresent(lt)) return null;
    if (isPresent(Validators.required(control))) return null;

    const v: number = +control.value;
    return v < +lt ? null : { lt: true };
  };
};
